export const capitalizeFirstLetter = (str: string) => (str ? str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()) : '');
